import { Typography } from '@mui/material'
import React, {useState}  from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {baseUrl} from '../../../api/APIServices';

import video50 from '../../../assets/images/video50.png'

const getMuiTheme = () => createTheme({
    components: {}
    });

function Instruction({instruction}) {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = () => {
        setOpen(false);
      };


  return (
    <ThemeProvider theme={getMuiTheme()}>
    <div style={{
        display:'flex', 
        backgroundColor:'#def1fc', 
        border:'solid 1px #ccc',
        margin:'10px 0px'
    }}
    onClick={handleClickOpen} 
    >
   
        <div style={{width: '20%', display:'flex', justifyContent:'center', padding: '5px', flexDirection:'column', alignItems:'center'}}>
            <img  width={30} height={30} src={video50} />
        </div>
        <div  style={{ width: '80%', padding: '5px'}}>
          <div>
            <Typography sx={{fontSize:'16px', fontWeight:'bold'}}>  {instruction.name}</Typography>
          </div>
            <Typography>
              {instruction.details}
            </Typography>
        </div>
    </div>

    <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              minWidth: "650px", 
              minHeight: "400px",  
              display:'flex',
              fontFamily: 'Open Sans'// Set your width here
            },
            "& .MuiDialogContent-root":{
                padding:'10px'
            },
            "& .MuiDialogTitle-root":{
                padding:'10px 5px 0px 10px'
            }
          },
        }}
        >
          <DialogTitle id="alert-dialog-title"> {instruction.name} </DialogTitle>
            <DialogContent>
                <CardMedia
                    component='video'
                    image={`${baseUrl}/${instruction.path}`}
                    controls
                    width={640}
                    height={380}
                    autoPlay
                />
            </DialogContent>
          <DialogActions>
            <Button color='primary'  size='small' variant="contained"  
                 onClick={handleClose} autoFocus>
              {t('close')}
            </Button>
          </DialogActions>
        </Dialog>
    </ThemeProvider>
  )
}

export default Instruction